import React, { createContext, useState, useEffect } from 'react';
import api from 'lib/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const attemptUserLogin = async () => {
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        const userData = await api.auth.profile();
        setUser(userData);
        setIsLoggedIn(true);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setIsLoggedIn(false);
        setUser(null);
      }
    } else {
      setIsLoggedIn(false);
      setUser(null);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    attemptUserLogin();

    const handleStorageChange = (event) => {
      if (event.key === 'authToken') {
        attemptUserLogin();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleLogin = async (token) => {
    localStorage.setItem('authToken', token);
    setIsLoading(true);
    try {
      const userData = await api.auth.profile();
      setUser(userData);
      setIsLoggedIn(true);
    } catch (error) {
      console.error('Error fetching user data:', error);
      setIsLoggedIn(false);
      setUser(null);
    }
    setIsLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsLoggedIn(false);
    setIsLoading(false);
    setUser(null);
  };

  const refreshUser = async () => {
    if (localStorage.getItem('authToken')) {
      try {
        const userData = await api.auth.profile();
        setUser(userData);
      } catch (error) {
        console.error('Error refreshing user data:', error);
      }
    }
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, handleLogin, handleLogout, isLoading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
